import { ref } from 'vue'
import type { BuffInfoType, FightResType } from '@/types/fight'
import { useUserStore } from '@/stores/modules/user'

export function useFightInfoPanel() {
  const userStore = useUserStore()
  const fightMessageList = ref<string[]>([])
  const curMp = ref(userStore.userAttr.mp)
  const curCdList = ref<[number, number][]>([])
  const curBuffInfoList = ref<BuffInfoType[]>([])
  const curDebuffInfoList = ref<BuffInfoType[]>([])
  const realUserAttr = ref<any>()

  function pushFightMessage(message: string) {
    fightMessageList.value.push(message)
    const length = fightMessageList.value.length
    if (length > 60) {
      fightMessageList.value = fightMessageList.value.slice(Math.max(length - 30, 0))
    }
  }

  function applyFightRes(res: FightResType, fightText: string) {
    pushFightMessage(fightText)
    curMp.value = res.mp
    curCdList.value = res.cdList
    curBuffInfoList.value = res.buffInfoList || []
    curDebuffInfoList.value = res.debuffInfoList || []
    realUserAttr.value = res.realUserAttr
  }

  function resetFightInfoPanel() {
    fightMessageList.value = []
    curCdList.value = []
    curBuffInfoList.value = []
    curDebuffInfoList.value = []
    realUserAttr.value = undefined
  }

  return {
    fightMessageList,
    curMp,
    curCdList,
    curBuffInfoList,
    curDebuffInfoList,
    realUserAttr,
    pushFightMessage,
    applyFightRes,
    resetFightInfoPanel,
  }
}
